/**
 * Created by Ivan on 21.01.2026
 */

const TropicalExpeditionFeastView = cc.Node.extend({
    ctor: function (window) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.window = window;

        const table = this.createTable();
        table.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.TropicalExpeditionFeastView;
        const mission = window.mission;

        const titleSlot = this.backgroundSpine.getSlot("slot_title");
        const helpSlot = this.backgroundSpine.getSlot("slot_help");
        const timerSlot = this.backgroundSpine.getSlot("slot_timer");
        const timerBgSlot = this.backgroundSpine.hasSlot("slot_timer_bg") && this.backgroundSpine.getSlot("slot_timer_bg");
        const closeSlot = this.backgroundSpine.hasSlot("slot_close") && this.backgroundSpine.getSlot("slot_close");
        const clockSlot = this.backgroundSpine.getSlot("slot_clock");

        const mainTitle = cleverapps.UI.generateOnlyText(Messages.get("ExpeditionFeastWindow.title"), cleverapps.styles.FONTS.TROPICAL_EXPEDITIONFEAST_MAIN_TITLE_TEXT);
        titleSlot.addChild(mainTitle);
        mainTitle.setAlignment(titleSlot.width / 2, titleSlot.height / 2);
        mainTitle.fitTo(titleSlot.width, titleSlot.height);

        const helpButton = new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.help_button_transparent,
            callback: () => {
                GuideWindow.createMissionRulesWindow(this.window.mission);
            }
        });
        helpSlot.addChild(helpButton);
        helpButton.setAlignment(helpSlot.width / 2, helpSlot.height / 2);
        helpButton.setScale(styles.helpButton.scale);
        helpButton.baseScale = helpButton.scale;

        if (closeSlot) {
            const closeButton = this.tableCloseButton = new CloseRoundButton({
                onClicked: window.close.bind(window),
                styles: styles.closeButton
            });
            closeSlot.addChild(closeButton);
        }

        if (timerBgSlot) {
            const timerBg = new cc.Scale9Sprite(bundles.timer.frames.timer_bg_png);
            timerBg.setContentSize2(timerBgSlot.getContentSize());
            timerBgSlot.addChild(timerBg);
            timerBg.setAlignment(timerBgSlot.width / 2, timerBgSlot.height / 2);
        }

        if (mission.isRunning()) {
            let timeLeft = mission.getTimeLeft();
            if (timeLeft > 0) {
                timeLeft = new cleverapps.CountDown(timeLeft, {
                    onFinish: window.close.bind(window)
                });
            }

            const timer = new cleverapps.CountDownView(timeLeft, {
                font: cleverapps.styles.FONTS.TROPICAL_EXPEDITIONFEAST_TIMER_TEXT
            });
            timerSlot.addChild(timer);
            timer.fitTo(timerSlot.width, timerSlot.height);
            timer.setAlignment(timerSlot.width / 2, timerSlot.height / 2);
        } else {
            const finishTitle = cleverapps.UI.generateOnlyText(Messages.get("FeastMissionWindow.finished"), cleverapps.styles.FONTS.TROPICAL_EXPEDITIONFEAST_TIMER_TEXT);
            timerSlot.addChild(finishTitle);
            finishTitle.setAlignment(timerSlot.width / 2, timerSlot.height / 2);
            finishTitle.fitTo(timerSlot.width, timerSlot.height);
        }

        const clock = new cc.Sprite(bundles.timer.frames.timer_png);
        clockSlot.addChild(clock);
        clock.setPosition(clockSlot.width / 2, clockSlot.height / 2);

        const button = this.createButton();

        const view = new cleverapps.Layout([table, button].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        this.setContentSize2(view.getContentSize());
        this.addChild(view);
        view.setAlignment(styles.content);
    },

    createTable: function () {
        const mission = this.window.mission;
        const jsons = bundles.expeditionfeast_window.jsons;

        const json = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL && jsons.mission_board_vertical
            ? jsons.mission_board_vertical : jsons.mission_board;

        const background = this.backgroundSpine = new cleverapps.Spine(json);
        if (background.hasAnimation("open")) {
            background.setAnimationAndIdleAfter("open", "idle");
        } else {
            background.setAnimation(0, "idle", true);
        }

        const tableSlot = background.getSlot("slot_table");
        const table = this.window.mission.runningCompetition.table;
        const tableView = this.tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !table.scrollDisabled,
            mouseScroll: !table.scrollDisabled,
            dock: { toEnd: false }
        });

        new TableHandler(table, tableView, {
            id: mission.type,
            height: tableSlot.height,
            rowConstructor: TropicalExpeditionFeastRowView,
            rowOptions: {
                width: tableSlot.width,
                dataIcon: cleverapps.skins.getSlot("missionTableRowIcon", { type: Mission.TYPE_EXPEDITION_FEAST }),
                scoreTooltip: "ExpeditionFeastWindow.tooltip.amount",
                mission
            }
        });

        tableSlot.addChild(tableView);
        tableView.setAlignment(tableSlot.width / 2, tableSlot.height / 2);

        const skin = (Mission.GetMissionType(this.window.mission.type) === Mission.TYPE_EXPEDITION_FEAST ? cleverapps.meta.selectedLocationId() : "")
            + this.window.mission.getName();

        if (background.hasSkin(skin)) {
            background.setSkin(skin);
        }

        if (connector.info.isMobile && cleverapps.resolution.isHorizontal()) {
            background.setScale(1.1);
        }

        return background;
    },

    createButton: function () {
        const styles = cleverapps.styles.TropicalExpeditionFeastView;

        const mission = this.window.mission;

        if (mission.isRunning() && ["merge", "merge2"].includes(cleverapps.config.type)) {
            return;
        }

        let options = {
            width: styles.button.width,
            height: styles.button.height,
            type: styles.button.red && cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("Play").toUpperCase(),

            onClicked: function () {
                this.window.close();

                cleverapps.focusManager.distract({
                    focus: "MissionPlayButtonPressed",
                    action: function (f) {
                        Level.WantsToPlay(f);
                    }
                });
            }.bind(this)
        };

        if (!mission.isRunning()) {
            options = Object.assign(options, {
                type: cleverapps.styles.UI.Button.Images.button_blue,
                text: Messages.get(mission.getPrize() ? "ClaimPrize.Button.text" : "Close"),
                onClicked: this.window.close.bind(this.window)
            });
        }

        const button = new cleverapps.UI.Button(options);
        button.setAlignment(styles.button);
        return button;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TROPICAL_EXPEDITIONFEAST_MAIN_TITLE_TEXT: {
        size: 90,
        color: new cc.Color(255, 234, 0, 255),
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    TROPICAL_EXPEDITIONFEAST_TIMER_TEXT: {
        name: "nostroke",
        size: 42,
        color: new cc.Color(137, 64, 44, 255)
    }
});

cleverapps.styles.TropicalExpeditionFeastView = {
    margin: 30,

    table: {
        margin: -2,
        innerPadding: 0
    },

    contentPadding: {
        bottom: 70
    },

    button: {
        x: { align: "center", dx: -25 },
        y: { align: "center" },
        width: 400,
        height: 110,
        red: true
    },

    helpButton: {
        scale: 0.85
    },

    closeButton: {
        scale: [0.7, 1, 1],
        x: { align: "center" },
        y: { align: "center" }
    },

    content: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
